export default __webpack_public_path__ + "static/media/Home2v2.66afd39e.png";